import type { Schema } from 'ajv';
import { Type } from '@sinclair/typebox';

export const getStoreIdNameDict = (stores: { id: string; displayName: string }[]) => {
  const nameDict: { [id: string]: string } = {};
  stores.forEach((store) => {
    nameDict[store.id] = store.displayName;
  });
  return nameDict;
};

export const getIdsSchema = (stores: { id: string; displayName: string }[]): Schema => {
  const storeLiterals = stores.map((store) => Type.Literal(store.id));
  const storesUnion = Type.Union(storeLiterals);

  return Type.Array(storesUnion);
};
